import { render, staticRenderFns } from "./contactUs.vue?vue&type=template&id=8e6c4fd6&scoped=true"
var script = {}
import style0 from "./contactUs.vue?vue&type=style&index=0&id=8e6c4fd6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e6c4fd6",
  null
  
)

export default component.exports